import { Container, Subscribe as Sub } from 'unstated';
import { Map } from 'immutable';
import React from 'react';

const isSidebarOpen = window.innerWidth >= 321;

function initialState() {
  return {
    // UI
    windowWidth: window.innerWidth,
    sidebarOpen: isSidebarOpen,
    trainingModalOpen: false,

    // currentUser and auth
    authenticated: false,
    trialWarningOpen: false,
    ownerName: '',
    currentUser: Map(),
    currentAccount: Map(),
    sessions: Map(),

    // All of these resources are expected to be a Map of
    // items that each have a unique _id property.
    facilities: Map(),
    buildings: Map(),
    floors: Map(),
    markers: Map(),
    markerTypes: Map(),
    markerTypeCategories: Map(),
    categories: Map(),
    infographics: Map(),

    // Admin stuff
    users: Map(),
    invitations: Map(),
    permissions: Map(),
    plans: Map(),
    trainingTutorials: Map()
  };
}

export class AppContainer extends Container {
  constructor(props) {
    super(props);
    // Overwrite the very basic setState to handle immutable data
    // be sure to handle the _listeners call
    // https://github.com/jamiebuilds/unstated/blob/master/src/unstated.js
    this.setState = newState => {
      this.state = this.state.merge(newState);
      this._listeners.forEach(fn => fn());
    };
    this.state = Map(initialState());
  }

  // Replace the entire map at a given key
  set(path, map) {
    const newState = this.state.set(path, map);
    this.setState(newState);
  }

  // Add an item to its respective map. Note this can be
  // used to create or update an item in the map as
  // immutable.js method .set() does this.
  setIn(path, item) {
    const newState = this.state.setIn(path, item);
    this.setState(newState);
  }

  deleteIn(path) {
    const newState = this.state.deleteIn(path);
    this.setState(newState);
  }

  //useful for testing
  reset() {
    this.state = Map(initialState());
  }
}
/*
  This app only needs one instance of appContainer.
  We do not really follow the unstated docs of passing
  in the class AppContainer and allow unstated to
  manage the instances. Instead we make ONE instance
  and share it everywhere (which unstated does too
  under the hood) But we want to get at our state from
  externally of a subscribe component.
*/
export const appContainer = new AppContainer();

export const Subscribe = ({ to, render }) => <Sub to={to}>{render}</Sub>;

// Throttle and listen to window resize
// See notes in below link about IE polyfill
// https://developer.mozilla.org/en-US/docs/Web/Events/resize
(function() {
  var throttle = function(type, name, obj) {
    obj = obj || window;
    var running = false;
    var func = function() {
      if (running) {
        return;
      }
      running = true;
      window.requestAnimationFrame(function() {
        obj.dispatchEvent(new window.CustomEvent(name));
        running = false;
      });
    };
    obj.addEventListener(type, func);
  };

  /* init - you can init any event */
  throttle('resize', 'optimizedResize');
})();

// set window width in state on change
window.addEventListener('optimizedResize', function(event) {
  appContainer.set('windowWidth', event.target.innerWidth);
});



// WEBPACK FOOTER //
// ./src/contexts/app.js